export const LIB_VERSION = '18.5.3'; // autogenerated
//# sourceMappingURL=version.js.map